export const inspectTable_1 = [
  {
    content: "1. 작업장 (안전보건규칙 제3조∼제20조)",
    isChecked: "",
  },
  {
    content: "2. 통로 (안전보건규칙 제21조∼제30조)",
    isChecked: "",
  },
  {
    content: "3. 보호구지급 및 관리 (안전보건규칙 제31조∼제34조)",
    isChecked: "",
  },
  {
    content: "4. 관리감독자의 직무, 사용제한 등 (안전보건규칙 제35조∼제41조)",
    isChecked: "",
  },
  {
    content: "5. 추락 또는 붕괴에 의한 위험방지 (안전보건규칙 제42조∼제53조)",
    isChecked: "",
  },
  {
    content: "6. 비계 (안전보건규칙 제54조∼제71조)",
    isChecked: "",
  },
  {
    content: "7. 환기장치 (안전보건규칙 제72조∼제78조)",
    isChecked: "",
  },
  {
    content: "8. 휴게시설 (안전보건규칙 제79조∼제82조)",
    isChecked: "",
  },
  {
    content: "9. 잔재물 등의 조치기준 (안전보건규칙 제83조∼제85조)",
    isChecked: "",
  },
];
export const inspectTable_2 = [
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "1. 기계 등의 일반기준 (안전보건규칙 제86조∼제99조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "2. 공작기계 (안전보건규칙 제100조∼제102조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "3. 프레스 및 전단기 (안전보건규칙 제103조∼제104조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "4. 목재가공용 기계 (안전보건규칙 제105조∼제110조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "5. 원심기 및 분쇄기둥 (안전보건규칙 제111조∼제113조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "6. 고속회전체 (안전보건규칙 제114조∼제115조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "7. 보일러 (안전보건규칙 제116조∼제120조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "8. 사출성형기 (안전보건규칙 제121조∼제131조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "9. 양중기 (안전보건규칙 제132조∼제170조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "10. 차량계 하역운반기계 (안전보건규칙 제171조∼제190조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "11. 컨베이어 (안전보건규칙 제191조∼제195조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "12. 건설기계 등 (안전보건규칙 제196조∼제221조)",
    isChecked: "",
  },
  {
    title: "기계 기구 및 그 밖의 설비에 의한 위험 예방",
    content: "13. 산업용 로봇 (안전보건규칙 제222조∼제224조)",
    isChecked: "",
  },

  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "1. 위험물 등의 취급 등 (안전보건규칙 제225조∼제238조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "2. 화기 등의 관리 (안전보건규칙 제239조∼제246조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "3. 응융고열물 등에 의한 위험예방 (안전보건규칙 제247조∼제254조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "4. 화학설비·압력용기 등 (안전보건규칙 제255조∼제279조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "5. 건조설비 (안전보건규칙 제280조∼제284조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "6. 아세틸렌 용접장치 (안전보건규칙 제285조∼제290조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "7. 가스집합 용접장치 (안전보건규칙 제291조∼제295조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지",
    content: "8. 폭발·화재 및 위험물 누출에 의한 위험방지 (안전보건규칙 제296조∼제300조)",
    isChecked: "",
  },

  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지 ",
    content: "1. 위험물 등의 취급 등 (안전보건규칙 제225조∼제238조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지 ",
    content: "2. 화기 등의 관리 (안전보건규칙 제239조∼제246조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지 ",
    content: "3. 응융고열물 등에 의한 위험예방 (안전보건규칙 제247조∼제254조)",
    isChecked: "",
  },
  {
    title: "폭발 화재 및 위험물누출에 의한 위험 방지 ",
    content: "4. 화학설비∙압력용기 등 (안전보건규칙 제255조∼제279조)",
    isChecked: "",
  },

  {
    title: "건설작업 등에 의한 위험 예방",
    content: "1. 거푸집 동바리 및 거푸집 (안전보건규칙 제328조∼제337조)",
    isChecked: "",
  },
  {
    title: "건설작업 등에 의한 위험 예방",
    content: "2. 굴착작업 등의 위험방지 (안전보건규칙 제338조∼제379조)",
    isChecked: "",
  },
  {
    title: "건설작업 등에 의한 위험 예방",
    content: "3. 철골작업 시의 위험방지 (안전보건규칙 제380조∼제383조)",
    isChecked: "",
  },
  {
    title: "건설작업 등에 의한 위험 예방",
    content: "4. 해체작업시의 위험방지 (안전보건규칙 제384조)",
    isChecked: "",
  },

  {
    title: "기타",
    content: "1. 중량물 취급 시의 위험방지 (안전보건규칙 제385조∼제386조)",
    isChecked: "",
  },
  {
    title: "기타",
    content: "2. 하역작업 등에 의한 위험방지 (안전보건규칙 제387조∼제404조)",
    isChecked: "",
  },
  {
    title: "기타",
    content: "3. 벌목작업에 의한 위험방지 (안전보건규칙 제405조∼제406조)",
    isChecked: "",
  },
  {
    title: "기타",
    content: "4. 궤도 관련 작업 등에 의한 위험방지 (안전보건규칙 제407조∼제419조)",
    isChecked: "",
  },
];
export const inspectTable_3 = [
  {
    content: "1. 관리대상 유해물질에 의한 건강장해 예방 (안전보건규칙 제420조∼제451조)",
    isChecked: "",
  },
  {
    content: "2. 허가대상 유해물질, 석면에 의한 건강장해 예방 (안전보건규칙 제452조∼제497조의3)",
    isChecked: "",
  },
  {
    content: "3. 금지유해물질에 의한 건강장해 예방 (안전보건규칙 제498조∼제511조)",
    isChecked: "",
  },
  {
    content: "4. 소음 및 진동에 의한 건강장해 예방 (안전보건규칙 제512조∼제521조)",
    isChecked: "",
  },
  {
    content: "5. 이상기압에 의한 건강장해 예방 (안전보건규칙 제522조∼제557조)",
    isChecked: "",
  },
  {
    content: "6. 온도습도에 의한 건강장해 예방 (안전보건규칙 제558조∼제572조)",
    isChecked: "",
  },
  {
    content: "7. 방사선에 의한 건강장해 예방 (안전보건규칙 제573조∼제591조)",
    isChecked: "",
  },
  {
    content: "8. 병원체에 의한 건강장해 예방 (안전보건규칙 제592조∼제604조)",
    isChecked: "",
  },
  {
    content: "9. 분진에 의한 건강장해 예방 (안전보건규칙 제605조∼제617조)",
    isChecked: "",
  },
  {
    content: "10. 밀폐공간 작업으로 인한 건강장해 예방 (안전보건규칙 제618조∼제644조)",
    isChecked: "",
  },
  {
    content: "11. 사무실에서의 건강장해 예방 (안전보건규칙 제646조∼제655조)",
    isChecked: "",
  },
  {
    content: "12. 근골격계부담작업으로 인한 건강장해 (안전보건규칙 제656조∼제666조)",
    isChecked: "",
  },
  {
    content: "13. 그 밖의 유해인자에 의한 건강장해 예방 (안전보건규칙 제667조∼제670조)",
    isChecked: "",
  },
];
export const inspectTable_4 = [
  {
    content: "1. 특수형태 근로종사자 등에 대한 안전·보건조치  (안전보건규칙 제672조∼제673조)",
    isChecked: "",
  },
]
